import { useStaffText } from '../ui/StaffText'
import { tickerSeconds } from './screenBindings'
import type { LayoutElement } from './types'
import '../styles/ticker.css'

/** One scrolling line: the element's own lines, then the playing playlist's; nothing when there are none. */
export function Ticker({ element, lines, preview }: { element: LayoutElement; lines: readonly string[]; preview?: boolean }) {
  const { say } = useStaffText()
  const shown = lines.length > 0 ? lines : preview ? [say('signage.tickerSample')] : []
  if (shown.length === 0) return null
  const text = shown.join('   •   ')
  return (
    <div className="layout-ticker" style={{ fontSize: Math.round(element.h * 0.55 * (element.style?.scale ?? 1)) }}>
      <span className="layout-ticker__run" style={{ animationDuration: `${tickerSeconds(text)}s` }}>
        {text}
      </span>
    </div>
  )
}
